import {onDestroy, onMount} from "svelte";

const CSS_ID = "fast-simon-upsell-cross-sell-css"
const CSS_ID_2 = "fast-simon-upsell-crossell-css"
const TARGET_CSS_ID = "upsell-cross-sell-css"
const TARGET_CSS_ID_2 = "upsell-crossell-css"

const config = {childList: true, subtree: true};

export default function useCustomCSS(target: ShadowRoot | HTMLElement) {
    function callback() {
        let style = target.querySelector("#" + TARGET_CSS_ID);
        if (!style) {
            style = target.querySelector("#" + TARGET_CSS_ID_2);
        }

        let css = document.getElementById(CSS_ID);
        if (!css) {
            css = document.getElementById(CSS_ID_2);
        }

        if (style && css) {
            style.innerHTML = css.innerHTML
        }
    }

    const observer = new MutationObserver(callback);


    onMount(() => {
        const css = document.getElementById(CSS_ID);
        if (css) {
            const style = document.createElement('style');
            style.id = TARGET_CSS_ID;
            style.innerHTML = css.innerHTML;
            target.appendChild(style);

            observer.observe(css, config);
        }
    });

    onDestroy(() => {
        observer.disconnect();
    })
}